import { render, staticRenderFns } from "./FacebookIcon.vue?vue&type=template&id=f9b6afba&scoped=true&"
import script from "./FacebookIcon.vue?vue&type=script&lang=js&"
export * from "./FacebookIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9b6afba",
  null
  
)

export default component.exports